document.addEventListener('DOMContentLoaded',function(){const menuToggle=document.getElementById('mobileMenuToggle');const mobileMenu=document.getElementById('mobileMenu');if(menuToggle&&mobileMenu){const overlay=document.getElementById('menuOverlay')||document.querySelector('.menu-overlay');const toggleMenu=function(){const isOpen=mobileMenu.classList.contains('active');if(isOpen){mobileMenu.classList.remove('active');menuToggle.classList.remove('active');if(overlay)overlay.classList.remove('active');window.GuyDom.unlockScroll('mobile-menu');menuToggle.setAttribute('aria-expanded','false')}else{mobileMenu.classList.add('active');menuToggle.classList.add('active');if(overlay)overlay.classList.add('active');window.GuyDom.lockScroll('mobile-menu');menuToggle.setAttribute('aria-expanded','true')}};menuToggle.addEventListener('click',toggleMenu);if(overlay){overlay.addEventListener('click',function(){mobileMenu.classList.remove('active');menuToggle.classList.remove('active');overlay.classList.remove('active');window.GuyDom.unlockScroll('mobile-menu');menuToggle.setAttribute('aria-expanded','false')})}document.addEventListener('keydown',function(e){if(e.key==='Escape'&&mobileMenu.classList.contains('active')){mobileMenu.classList.remove('active');menuToggle.classList.remove('active');if(overlay)overlay.classList.remove('active');window.GuyDom.unlockScroll('mobile-menu');menuToggle.setAttribute('aria-expanded','false')}})}document.querySelectorAll('a[href^="#"]').forEach(anchor=>{anchor.addEventListener('click',function(e){const href=this.getAttribute('href');if(href!=='#'&&href.length>1){e.preventDefault();const target=document.querySelector(href);if(target){target.scrollIntoView({behavior:'smooth',block:'start'});/* il focus segue lo scroll: senza, il link 'salta al contenuto' lasciava la tastiera in cima */if(!target.hasAttribute('tabindex'))target.setAttribute('tabindex','-1');target.focus({preventScroll:true})}}})});

/* Page Transition Fade-Out — solo su browser SENZA View Transitions API.
   Su browser moderni il browser gestisce nativamente la transizione
   cross-document (vedi @view-transition in core.css), il fadeOut custom
   creerebbe un doppio fade. */
if(!(window.GuyDom?window.GuyDom.crossDocVT:('onpagereveal' in window))){
  document.querySelectorAll('a:not([href^="#"]):not([href^="javascript"]):not([target="_blank"])').forEach(link=>{
    link.addEventListener('click',function(e){
      // Cmd/Ctrl/Shift/Alt+click = "apri in nuova scheda/finestra": il browser
      // deve gestirlo lui. Col preventDefault qui sotto il link si apriva
      // nella scheda CORRENTE, perdendo la pagina.
      if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button!==0||e.defaultPrevented)return;
      const href=this.getAttribute('href');
      if(href&&!href.startsWith('#')&&!href.startsWith('javascript')&&!this.hasAttribute('target')){
        e.preventDefault();
        document.body.classList.add('page-transition-out');
        setTimeout(()=>{window.location.href=href},400);
      }
    });
  });
}

/* ───── POLICY NAV — barra orizzontale scorrevole tra le pagine policy ─────
   Le pagine /policies/* sono renderizzate da Shopify con .shopify-policy__container.
   Iniettiamo una nav coerente col brand sopra al titolo. La voce attiva è
   quella della pagina corrente. */
// Anche con prefisso lingua (/it/policies/...): la regola cercava solo /policies/
// e in italiano la barra non compariva.
var policyMatch = window.location.pathname.match(/^(\/[a-z]{2}(?:-[a-z]{2})?)?\/policies\//i);
if (policyMatch) {
    var langPrefix = policyMatch[1] || '';
    var isIt = (document.documentElement.lang || '').toLowerCase().indexOf('it') === 0;
    var container = document.querySelector('.shopify-policy__container');
    if (container && !document.querySelector('.policy-nav')) {
      var policies = [
        { label: isIt ? 'Resi' : 'Returns', path: langPrefix + '/policies/refund-policy' },
        { label: isIt ? 'Spedizioni' : 'Shipping', path: langPrefix + '/policies/shipping-policy' },
        { label: isIt ? 'Termini' : 'Terms', path: langPrefix + '/policies/terms-of-service' },
        { label: 'Privacy', path: langPrefix + '/policies/privacy-policy' }
      ];

      var nav = document.createElement('nav');
      nav.className = 'policy-nav';
      nav.setAttribute('aria-label', 'Policies');
      var current = window.location.pathname.replace(/\/$/, '');
      policies.forEach(function (p) {
        var a = document.createElement('a');
        a.href = p.path;
        a.textContent = p.label;
        if (current === p.path) {
          a.classList.add('is-active');
          a.setAttribute('aria-current', 'page');
        }
        nav.appendChild(a);
      });
      // Inserisce la nav SOTTO il titolo della policy (prima del corpo testo)
      var title = container.querySelector('.shopify-policy__title');
      var bodyEl = container.querySelector('.shopify-policy__body');
      if (title && title.nextSibling) {
        container.insertBefore(nav, title.nextSibling);
      } else if (bodyEl) {
        container.insertBefore(nav, bodyEl);
      } else {
        container.insertBefore(nav, container.firstChild);
      }

      // Se il contenuto sta in una sola colonna, centralo (no scroll orizzontale).
      var body = container.querySelector('.shopify-policy__body');
      if (body) {
        var checkSingle = function () {
          body.classList.remove('is-single');
          // una colonna sola = lo scroll width non supera di molto il client width
          if (body.scrollWidth <= body.clientWidth + 8) body.classList.add('is-single');
        };
        checkSingle();
        window.addEventListener('resize', checkSingle);
        // Colonne orizzontali (stile e-reader, voluto): la rotella del mouse
        // scorre in verticale e qui non succedeva nulla, il recesso restava
        // fuori vista. La rotella ora sfoglia le colonne; ai bordi lascia
        // scorrere la pagina come sempre.
        body.addEventListener('wheel', function (e) {
          if (body.classList.contains('is-single') || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
          var max = body.scrollWidth - body.clientWidth;
          if ((e.deltaY > 0 && body.scrollLeft >= max - 1) || (e.deltaY < 0 && body.scrollLeft <= 0)) return;
          e.preventDefault();
          body.scrollLeft += e.deltaY;
        }, { passive: false });
      }
    }
  }
});


/* ─── PROTEZIONE MEDIA (deterrente) ─────────────────────────────────────────
   Niente menu contestuale (salva immagine/video) né drag sui media del sito.
   Non è una protezione assoluta (screenshot/devtools restano possibili):
   scoraggia il salvataggio casuale. Il blocco drag/long-press CSS è in core.css. */
document.addEventListener('contextmenu', function (e) {
  if (e.target.closest && e.target.closest('img,video')) e.preventDefault();
});
document.addEventListener('dragstart', function (e) {
  if (e.target.closest && e.target.closest('img,video')) e.preventDefault();
});

/* ─── FIX bfcache: pannello prodotto invisibile al RITORNO ──────────────────
   Su browser senza View Transitions, il click su un link aggiunge
   body.page-transition-out (fade d'uscita). Tornando indietro, il browser
   ripristina la pagina dalla bfcache con quella classe ancora attiva →
   .product-details-right resta a opacity:0 (animation:fadeOut forwards).
   Alla ricomparsa (anche da bfcache) togliamo la classe: il pannello riappare. */
window.addEventListener('pageshow', function () {
  document.body.classList.remove('page-transition-out');
});

/* ─── FIX taglie "vuote" al 1° ingresso a freddo ────────────────────────────
   Segnalazione: aprendo un prodotto la PRIMA volta la fila taglie (S/M/L) non
   compare, poi riaprendo sì. Il markup/CSS/JS le rende sempre (verificato); il
   problema è che alcuni browser, dopo una view-transition cross-document, NON
   ridipingono subito quel sotto-albero. Forziamo un repaint del pannello alla
   comparsa (nudge di opacity impercettibile), una volta DOPO il morph. */
var guyProductRepaintFrame = 0;
function guyForceProductRepaint() {
  var el = document.querySelector('.product-details-right');
  if (!el) return;
  guyProductRepaintFrame = requestAnimationFrame(function () {
    el.style.opacity = '0.9999';
    guyProductRepaintFrame = requestAnimationFrame(function () {
      el.style.opacity = '';
      guyProductRepaintFrame = 0;
    });
  });
}
window.GuyDom.onEntrance(guyForceProductRepaint);
window.addEventListener('pagehide', function () {
  cancelAnimationFrame(guyProductRepaintFrame);
  guyProductRepaintFrame = 0;
  var el = document.querySelector('.product-details-right');
  if (el) el.style.opacity = '';
});

/* ─── MENU MOBILE CHIUSO FUORI DAL TAB ──────────────────────────────────────
   Chiuso è solo rimpicciolito a zero (transform): i suoi link restavano nel
   percorso del Tab, invisibili. inert li toglie finché il menu non è aperto. */
document.addEventListener('DOMContentLoaded', function () {
  var m = document.getElementById('mobileMenu');
  if (!m) return;
  var sync = function () { m.inert = !m.classList.contains('active'); };
  sync();
  new MutationObserver(sync).observe(m, { attributes: true, attributeFilter: ['class'] });
});

/* ─── NAVIGAZIONE DA TASTIERA: html.kbd-nav ─────────────────────────────────
   Gli anelli di focus si vedono SOLO mentre si naviga con la tastiera: la
   classe entra al primo Tab/freccia e sparisce al primo tocco o click. Con dito
   e mouse il sito resta pulito anche quando il codice sposta il focus (apertura
   carrello, scelta in Styled With). Scelta estetica di Domenico. */
(function () {
  var root = document.documentElement;
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab' || e.key.indexOf('Arrow') === 0) root.classList.add('kbd-nav');
  }, true);
  ['pointerdown', 'touchstart'].forEach(function (t) {
    document.addEventListener(t, function () { root.classList.remove('kbd-nav'); }, { capture: true, passive: true });
  });
})();
